import * as sup from 'superstruct';

import { createResponseStruct } from '@/modules/api/utils/jsonApiStructs';
import { demoNegotiationResourceStruct } from '@/modules/demoNegotiation/api/resources/demoNegotiationResourceConsts';

export const getDemoNegotiationsResponseStruct = createResponseStruct({
  data: sup.array(demoNegotiationResourceStruct),
});

export type GetDemoNegotiationsResponse = sup.Infer<
  typeof getDemoNegotiationsResponseStruct
>;
